/* Shared by Checkbox and Radio. */
.input {
    border-color: light-dark(
        var(--mantine-color-gray-3),
        var(--mantine-color-dark-3)
    );
    background-color: var(--mantine-color-body);
    box-shadow: var(--mantine-shadow-xs);
    transition:
        background-color 120ms ease,
        border-color 120ms ease;
}

.input:checked {
    box-shadow: none;
}

.label {
    font-size: var(--mantine-font-size-sm);
}

/* Compact controls carry a secondary-style label. */
.root[data-size='xs'] .label {
    padding-inline-start: rem(4px);
    color: var(--mantine-color-dimmed);
    font-size: var(--mantine-font-size-xs);
    font-weight: 500;
}

.description {
    color: var(--mantine-color-dimmed);
}
